import { AxiosRequestConfig } from 'axios';
import { apiGet, apiPost, apiDelete } from './api';
import { IPermission } from '../interfaces/global';
// Request interceptor for API calls
const options: AxiosRequestConfig = {};

export async function fetchPermissions() {
  return await apiGet<AxiosRequestConfig, IPermission[]>('/us/permission', options);
}

export async function createEditPermission(permission: IPermission) {
  return await apiPost<AxiosRequestConfig, IPermission>('/us/permission', permission);
}

export async function deletePermission(permissionName: string) {
  return await apiDelete(`/us/permission/${permissionName}`);
}

export async function downloadPermissions() {
  return await apiGet<AxiosRequestConfig, { status: string }>('/us/permission/report/async-email');
}
